// extracted by mini-css-extract-plugin
export default {"root":"BasicInfoForm_root__qZNGS","after":"BasicInfoForm_after__Va88I"};